var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.classes},[(_vm.showNumber)?_c('span',[_vm._v(" "+_vm._s(_vm.convertedValue)+" "+_vm._s(_vm.unit)+" ")]):_c('span',[_c('i',[_vm._v(_vm._s(_vm.noValueDisplay))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }